import React from "react";

/**
 * BtnSignature — bouton signature WYVIO.
 * Variantes : "primary" (noir), "lime" (accent), "ghost" (outline).
 * Radius 12px, h-11 (44px), tracking-tight, flèche animée si `arrow`.
 */
export const BtnSignature = React.forwardRef(function BtnSignature(
  {
    variant = "primary",
    size = "md",
    arrow = false,
    icon: Icon = null,
    children,
    className = "",
    testid,
    ...props
  },
  ref,
) {
  const base =
    "wyvio-btn group inline-flex items-center justify-center gap-2 font-medium tracking-[-0.005em] rounded-[14px] transition-[background-color,color,box-shadow,transform] duration-[180ms] ease-[cubic-bezier(0.22,1,0.36,1)] active:translate-y-[1px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C8FF2F] focus-visible:ring-offset-2 focus-visible:ring-offset-white";
  const sizes = {
    md: "h-[46px] px-7 text-[14px]",
    sm: "h-9 px-4 text-[13px]",
    lg: "h-[54px] px-8 text-[15px]",
  };
  const variants = {
    primary:
      "bg-[#151515] text-white hover:bg-[#1a1a1c] shadow-[0_1px_0_0_rgba(255,255,255,0.06)_inset,0_1px_2px_rgba(15,15,15,0.2)]",
    lime:
      "bg-[#C8FF2F] text-[#151515] hover:bg-[#d4ff52] shadow-[0_1px_0_0_rgba(255,255,255,0.4)_inset,0_2px_16px_-2px_rgba(200,255,47,0.45)]",
    ghost:
      "bg-white/70 text-[#151515] border border-[#E5E5E0] hover:bg-white hover:border-[#D9D9D2] backdrop-blur-sm",
    dark:
      "bg-transparent text-[#6B6B67] hover:text-[#151515] hover:bg-[#EEEEE8]",
  };

  return (
    <button
      ref={ref}
      data-testid={testid}
      className={`${base} ${sizes[size]} ${variants[variant]} ${className}`}
      {...props}
    >
      {Icon && <Icon className="h-4 w-4" strokeWidth={2} />}
      <span>{children}</span>
      {arrow && (
        <span aria-hidden className="wyvio-btn-arrow ml-0.5">
          →
        </span>
      )}
    </button>
  );
});
